import React from 'react'
import { Table, OverlayTrigger } from 'react-bootstrap'
import Pagination from '../../../helpers/hoc/paginator/Pagination'
import './geofanceAlert.css'
import {
  getFormattedDate,
  secondsToHoursAndMinutes,
} from '../../../../utils/common-methods'
import NoRecordFound from '../../../helpers/hoc/noRecordFound'
import VehicleNRNTooltip from '../../../helpers/hoc/common-components/vehicle-nrn'


const RowButton = ({ renderTooltip, alertType, ingressDateTime, egressDateTime, fenceType, fenceOwnerType, fenceOwnerName }) => (
  <OverlayTrigger
    placement={alertType ? "auto" : "right"}
    delay={{ show: 0, hide: 0 }}
    overlay={renderTooltip({ alertType, ingressDateTime, egressDateTime, fenceType, fenceOwnerType, fenceOwnerName })}
  >
    <button className="row-btn  alert-recent-btn">
      <img
        src="/images/svgicon/info.svg"
        alt="info"
        style={{ width: 14, cursor: 'pointer' }}
      />
    </button>
  </OverlayTrigger>
)

const renderAlertType = (recent) => {
	if (recent.alertType === 'Ingress') {
		return 'Ingress Time'
	}

	if (recent.alertType === 'Egress') {
		return 'Egress Time'
	}

	if (recent.alertType === 'Dwell Time') {
		return 'Dwell Time'
	}

	if (recent.alertType === 'Return To Base') {
		return 'Time Since Last Egress'
	}
}

const renderAlertTime = (recent, renderAlertTimeTooltip) => {
  if (recent.alertType === 'Ingress') {
    return (
      <span
        className="alert-recent-td-span"
        style={{ color: '#E20909' }}
      >
        {recent.ingress_date_time ? getFormattedDate(recent.ingress_date_time) : 'NA'}
      </span>
    )
  }

  if (recent.alertType === 'Egress') {
    return (
      <span
        className="alert-recent-td-span"
        style={{ color: '#E20909' }}
      >
        {recent.egress_date_time ? getFormattedDate(recent.egress_date_time) : 'NA'}
      </span>
    )
  }

  if (recent.alertType === 'Dwell Time') {
    return (
      <span
        className="alert-recent-td-span"
        style={{ color: '#E20909' }}
      >
        {recent.dwell_time_in_sec ? secondsToHoursAndMinutes(recent.dwell_time_in_sec) : 'NA'}
        <RowButton
          renderTooltip={renderAlertTimeTooltip}
          egressDateTime={recent.egress_date_time ? getFormattedDate(recent.egress_date_time) : ''}
          ingressDateTime={recent.ingress_date_time ? getFormattedDate(recent.ingress_date_time) : ''}
          alertType={recent.alertType}
        />
      </span>
    )
  }

  if (recent.alertType === 'Return To Base') {
    return (
      <span
        className="alert-recent-td-span"
        style={{ color: '#E20909' }}
      >
        {recent.return_to_base_in_sec ? secondsToHoursAndMinutes(recent.return_to_base_in_sec) : 'NA'}
        <RowButton
          renderTooltip={renderAlertTimeTooltip}
          egressDateTime={recent.egress_date_time ? getFormattedDate(recent.egress_date_time) : ''}
          alertType={recent.alertType}
        />
      </span>
    )
  }

  return <span>NA</span>
}

const Row = ({ renderTooltip, renderAlertTimeTooltip, recent, index, currentPage, ITEMS_PER_PAGE }) => (
  <tr >
    <td className="alert-recent-td">
      <span className="alert-recent-td-span">
        {' '}
        {index +
          1 +
          ((currentPage - 1) * 10 + (currentPage - 1) * (ITEMS_PER_PAGE - 10)) +
          '.'}
      </span>
    </td>
    <td className="alert-recent-td">{recent.registration_number}
                          {recent?.nrn ?
                          <VehicleNRNTooltip
                            parameter1 = {recent.nrn}
                         />
                        : " "}
                      
    </td>
    <td className="alert-recent-td">{`${recent.oem} ${recent.model}`}</td>
    <td className="alert-recent-td">
      {recent.fence_name}
      <RowButton
        renderTooltip={renderTooltip}
        fenceOwnerName={recent.owner_name_label}
				fenceOwnerType={recent.owner_type_label}
				fenceType={recent.fence_type_label}
      />
    </td>
    <td className="alert-recent-td">{recent.alertType}</td>
    <td className="alert-recent-td">{renderAlertType(recent)}</td>
    <td className="alert-recent-td">
      {renderAlertTime(recent, renderAlertTimeTooltip)}
    </td>
  </tr>
)

const RecentReport = ({
  renderTooltip,
  renderAlertTimeTooltip,
  geoFanceReportData,
  page,
  setPage,
  loading,
  ITEMS_PER_PAGE,
  geoFanceReportDataCount,
}) => {
  return (
    <>
      <div className="col-12 col-md-12 col-lg-12   bg-white">
        {geoFanceReportData?.length ? (
          <div
            className=" bg-white mb-1 position-relative "
            style={{ width: '100%', boxShadow: '0px 3px 6px #00000029' }}
          >
            <Table
              responsive={true}
              borderless
              className="mb-0"
              id="myTable"
             
            >
              <thead
                style={{
                  marginBottom: '10px',
                }}
              >
                <tr
                  className="table-header"
                  style={{
                    color: '#1F2A5D  !important',
                    verticalAlign: 'baseline',
                  }}
                >
                  <th>
                    <span className="alert-recent-th">S.No.</span>
                  </th>
                  <th>
                    <span className="alert-recent-th">Vehicle No.</span>
                  </th>
                  <th>
                    <span className="alert-recent-th">OEM & Model</span>
                  </th>
                  <th>
                    <span className="alert-recent-th">Fence Name</span>
                  </th>
                  <th>
                    <span className="alert-recent-th">Alert Type</span>
                  </th>
                  <th>
                    <span className="alert-recent-th">Alert Value Type</span>
                  </th>
                  <th>
                    <span className="alert-recent-th">Alert Value</span>
                  </th>
                </tr>
                {!loading && geoFanceReportData?.length > 0 && (
                  <>
                    {geoFanceReportData?.map((item, index) => (
                      <Row
                        key={index}
                        recent={item}
                        index={index}
                        renderTooltip={renderTooltip}
                        renderAlertTimeTooltip={renderAlertTimeTooltip}
                        currentPage={page}
                        ITEMS_PER_PAGE={ITEMS_PER_PAGE}
                      />
                    ))}
                  </>
                )}
              </thead>
            </Table>

            <Pagination
              disabled={false}
              currentPage={page}
              setPage={setPage}
              totalPages={Math.ceil(
                (geoFanceReportDataCount || 0) / ITEMS_PER_PAGE
              )}
              data-testid='recent-report-pagination'
            />
          </div>
        ) : (
          <> </>
        )}

        {!geoFanceReportData?.length && !loading ? (
          <NoRecordFound></NoRecordFound>
        ) : (
          <></>
        )}
      </div>
    </>
  )
}

export default RecentReport
